const MD5 = require("crypto-js/md5");

const multipleChoice = () => {

  const multipleChoices = document.querySelectorAll('.wp-quiz-item--multiple-choice-text');

  multipleChoices.forEach(question => {


    const answers = question.querySelectorAll('[data-multiple-choice-answer]');
    answers.forEach(answer => {
      answer.addEventListener('click',() => {
        const solution = answer.dataset.solution;
        const answerText = answer.innerText;


        if(MD5(answerText) == solution) {
          question.classList.add('wp-quiz-item--is-right');
          question.classList.remove('wp-quiz-item--is-pristine');
          question.classList.remove('wp-quiz-item--is-wrong');
        } else {
          question.classList.add('wp-quiz-item--is-wrong');
          question.classList.remove('wp-quiz-item--is-pristine');
          question.classList.remove('wp-quiz-item--is-right');
        }
      });
    })

  });

}

window.addEventListener('DOMContentLoaded', multipleChoice, { once: true });
